// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2468B","content":"Consent_content__V7WKf","footer":"Consent_footer__1EBqk"};